/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Paywall_Special_Offer_TitleInputs */

const en_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Empower Your Focus</span> for the Challenges Ahead`)
};

const ar_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">عزز تركيزك</span> من أجل تحديات التركيز القادمة.`)
};

const de_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Stärken Sie Ihren Fokus</span> für die kommenden Fokus Herausforderungen.`)
};

const es_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Potencia tu concentración</span> para los próximos Desafíos de concentración.`)
};

const fr_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Améliorez votre concentration</span> pour le Défi de Concentration à venir.`)
};

const it_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Potenzia la tua concentrazione</span> per la Sfida di Concentrazione che ti attende.`)
};

const ja_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">集中力を高めて</span>、これからの集中チャレンジに備えよう。`)
};

const ko_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앞으로 다가올 집중 챌린지를 위해 <span style="STYLE">집중력을 키워보세요</span>.`)
};

const pt_br_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Potencialize seu foco</span> para o Desafio de Foco adiante.`)
};

const ru_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">Прокачайте концентрацию</span> для грядущих Заданий по фокусировке.`)
};

const th_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">เสริมพลังการโฟกัสของคุณ</span>เพื่อความท้าทายการโฟกัสที่รออยู่ข้างหน้า`)
};

const tr_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelecekteki Odaklanma Mücadeleleri için <span style="STYLE">odağını güçlendir</span>!`)
};

const zh_cn_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">解锁更强的专注功能</span>
迎接更多专注挑战`)
};

const zh_tw_starter_challenge_paywall_special_offer_title = /** @type {(inputs: Starter_Challenge_Paywall_Special_Offer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="STYLE">解鎖更強的專注功能</span>
迎接更多專注挑戰`)
};

/**
* | output |
* | --- |
* | "<span style=\"STYLE\">Empower Your Focus</span> for the Challenges Ahead" |
*
* @param {Starter_Challenge_Paywall_Special_Offer_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_paywall_special_offer_title = /** @type {((inputs?: Starter_Challenge_Paywall_Special_Offer_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Paywall_Special_Offer_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "ar") return ar_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "de") return de_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "es") return es_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "fr") return fr_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "it") return it_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "ja") return ja_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "ko") return ko_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "ru") return ru_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "th") return th_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "tr") return tr_starter_challenge_paywall_special_offer_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_paywall_special_offer_title(inputs)
	return zh_tw_starter_challenge_paywall_special_offer_title(inputs)
});